import { ReactNode, useEffect, useState } from "react";
import { Button, List, Popover } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation } from "react-router-dom";
import { useStyles } from "./TopBarNav.styles";

interface ITopBarNav {
    label: ReactNode;
    children: ReactNode;
}

// Top-bar navigation dropdown. Renders the items that used to live in the side
// drawer (locations tree, dashboard link, etc.) inside a Popover so the layout
// matches the Cedar refresh (no persistent side pane).
const TopBarNav = ({ label, children }: ITopBarNav) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);
    const location = useLocation();

    // Close on route change so picking a location dismisses the menu, while
    // expand/collapse toggles (no route change) keep it open.
    useEffect(() => {
        setAnchorEl(null);
    }, [location.pathname]);

    return (
        <>
            <Button
                onClick={(event) => setAnchorEl(event.currentTarget)}
                className={classes.trigger}
                disableRipple
            >
                {label}
                <ExpandMoreIcon className={open ? classes.expandIconOpen : classes.expandIcon} />
            </Button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                PaperProps={{ className: classes.paper }}
            >
                <List className={classes.list}>{children}</List>
            </Popover>
        </>
    );
};

export default TopBarNav;
